import { css } from '@linaria/core';
export const Root = {
    base: css ``,
    globalColor: css `
		& path {
			fill: rgb(var(--branding-color-logos));
		}
	`,
};
